// Get current redirect URI dynamically - works for both localhost and production
const getRedirectUri = () => {
    const origin = window?.location?.origin;
    return origin || 'http://localhost:4200'; // fallback for SSR
};

export const authConfig = {
    production: true,
    useMockAuth: false, // Set to true to use mock authentication for testing - TEMPORARILY USING MOCK AUTH
    msalConfig: {
        auth: {
            // TODO: Replace with your actual Azure AD application values
            // To avoid "approval required" dialog, you need to:
            // 1. Register your own app in Azure AD
            // 2. Configure minimal permissions (User.Read only)
            // 3. Grant admin consent for your organization
            clientId: '973c9cf5-83fd-4052-903b-7ac24c2cee9b', // Replace with your client ID
            authority: 'https://login.microsoftonline.com/09c7db79-cb84-41e2-bcb8-66a3b0d15d83', // Use 'common' for multi-tenant or your specific tenant ID
            redirectUri: getRedirectUri(),
            postLogoutRedirectUri: getRedirectUri(),
            navigateToLoginRequestUrl: false, // Important for SPA
        },
        cache: {
            cacheLocation: 'localStorage', // Store tokens in localStorage for persistence
            storeAuthStateInCookie: false, // Don't use cookies for modern browsers
            secureCookies: false // Set to true in production with HTTPS
        },
        system: {
            allowNativeBroker: false, // Disable for web apps
            windowHashTimeout: 60000, // Increase timeout for slower networks
            iframeHashTimeout: 6000,
            loadFrameTimeout: 0,
            navigateFrameWait: 0
        }
    }
};
